import { atom } from 'jotai';
export var CrawlerType;
(function (CrawlerType) {
    CrawlerType["Google"] = "google";
})(CrawlerType || (CrawlerType = {}));
export var GoogleCrawlerSubType;
(function (GoogleCrawlerSubType) {
    GoogleCrawlerSubType["GoogleAPIs"] = "google_apis";
    GoogleCrawlerSubType["AdsBot"] = "ads_bot";
    GoogleCrawlerSubType["AdSense"] = "mediapartners";
    GoogleCrawlerSubType["Image"] = "image";
    GoogleCrawlerSubType["News"] = "news";
    GoogleCrawlerSubType["Video"] = "video";
    GoogleCrawlerSubType["GoogleBot"] = "googlebot";
    GoogleCrawlerSubType["GoogleBot$Mobile"] = "googlebot(mobile)";
    GoogleCrawlerSubType["FeedFetcher"] = "feed_fetcher";
    GoogleCrawlerSubType["ReadAloud"] = "read_aloud";
    GoogleCrawlerSubType["Favicon"] = "favicon";
    GoogleCrawlerSubType["Storebot"] = "store_bot";
    GoogleCrawlerSubType["SiteVerification"] = "site_verification";
})(GoogleCrawlerSubType || (GoogleCrawlerSubType = {}));
export const $Crawler = atom({});
$Crawler.debugLabel = '$Crawler';
